import React, { Component } from 'react';
import { Confirm, Grid } from 'semantic-ui-react';

import { connect } from 'react-redux';
import ProjectsTable from '../../projects/components/ProjectsTable';
import { deleteProject } from '../../projects/scenes/singleProject/data/projectActions';
import { getProjectsList } from '../../projects/data/actions';
import { ANALYSIS_PROJECTS_LIST_SECTION, setActiveAnalysisSection } from '../data/actions';

import { EditProjectModal } from '../components/modals/index';
import { openEditModal } from '../data/ProjectList/modalActions';
import ProjectsPagination from '../../projects/components/ProjectsPagination';

class ListAnalysisProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteConfirmOpen: false,
      projectIdToDelete: null
    };

    this.openDeleteConfirm = this.openDeleteConfirm.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getProjectsList());
    this.props.dispatch(setActiveAnalysisSection(ANALYSIS_PROJECTS_LIST_SECTION));
  }

  /**
   * Opens the project deletion confirm modal
   * @param projectId
   */
  openDeleteConfirm(projectId) {
    this.setState({
      deleteConfirmOpen: true,
      projectIdToDelete: projectId
    });
  }

  openEditModal(project_id) {
    this.props.dispatch(openEditModal(project_id));
  }

  /**
   * Deletes a project
   */
  deleteProject() {
    this.props.dispatch(deleteProject(this.state.projectIdToDelete));

    this.setState({
      deleteConfirmOpen: false,
      projectIdToDelete: null
    });
  }

  /**
   * Cancel confirm handler
   */
  handleDeleteCancel() {
    this.setState({
      deleteConfirmOpen: false,
      projectIdToDelete: null
    });
  }

  render() {
    return (
      <Grid>
        <Grid.Row className="five column project-featured-top">
          <Grid.Column className="left floated">
            <h1 className="page-title">Projects list</h1>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <ProjectsTable
              deleteHandler={this.openDeleteConfirm}
              path={this.props.match.path}
              editHandler={this.openEditModal}
            />
            <ProjectsPagination />
          </Grid.Column>
        </Grid.Row>
        <Confirm
          key={1}
          open={this.state.deleteConfirmOpen}
          cancelButton="Cancel"
          confirmButton="Delete"
          content={`Delete project ${this.state.projectIdToDelete} ?`}
          onCancel={this.handleDeleteCancel}
          onConfirm={this.deleteProject}
        />
        ,
        <EditProjectModal isOpen={this.props.modals.edit} />
      </Grid>
    );
  }
}

export default connect(state => ({
  modals: state.analysis.projectsList.analysisModals
}))(ListAnalysisProjects);



// WEBPACK FOOTER //
// ./src/scenes/analysis/containers/ListAnalysisProjects.js